(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-blogrij-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scblogrijhome]').forEach(function (root) {
    var track = root.querySelector('[data-scblogrijhome-track]');
    var prev = root.querySelector('[data-scblogrijhome-prev]');
    var next = root.querySelector('[data-scblogrijhome-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.sc-blogrijhome__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    }

    function update() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-blogrij"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scblogrij]').forEach(function (root) {
    var track = root.querySelector('[data-scblogrij-track]');
    var prev = root.querySelector('[data-scblogrij-prev]');
    var next = root.querySelector('[data-scblogrij-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.sc-blogrij__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    }

    function update() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-boxpagina"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scpp-media]').forEach(function (root) {
    var slides = root.querySelectorAll('.sc-pp__slide');
    var thumbs = root.querySelectorAll('.sc-pp__thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-go');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === idx); });
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });
  });

  document.querySelectorAll('[data-scpp-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.sc-pp__tab');
    var panels = root.querySelectorAll('.sc-pp__panel');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-tab');
        tabs.forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === idx); });
      });
    });
  });

  document.querySelectorAll('[data-scpp-counter]').forEach(function (el) {
    var from = parseInt(el.getAttribute('data-from'), 10);
    var to = parseInt(el.getAttribute('data-to'), 10);
    var finalText = el.getAttribute('data-final');
    if (isNaN(from) || isNaN(to) || to >= from) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) { el.textContent = finalText; return; }
    var fmt;
    try { fmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }); }
    catch (e) { el.textContent = finalText; return; }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || done) return;
        done = true; io.disconnect();
        var duration = 900, start = null;
        function frame(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var value = Math.round(from + (to - from) * eased);
          el.textContent = fmt.format(value / 100);
          if (p < 1) { requestAnimationFrame(frame); } else { el.textContent = finalText; }
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-check"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scchk]').forEach(function (root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('.sc-chk__step'));
    var dots = root.querySelectorAll('.sc-chk__dot');
    var result = root.querySelector('.sc-chk__result');
    var redo = root.querySelector('.sc-chk__redo');
    var dataEl = root.querySelector('[data-scchk-data]');
    if (!steps.length || !dataEl) return;

    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var answers = { reinig: null, creme: null, spf: null, avond: null };
    var currentStep = 0;

    function visibleSteps() {
      return answers.creme === 'nee' ? [0, 1, 3] : [0, 1, 2, 3];
    }

    function showStep(stepIndex) {
      steps.forEach(function (s) {
        s.classList.toggle('is-active', parseInt(s.getAttribute('data-step'), 10) === stepIndex);
      });
      result.classList.remove('is-active');
      updateDots();
    }

    function updateDots() {
      var vis = visibleSteps();
      var idx = vis.indexOf(currentStep);
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === idx);
        d.classList.toggle('is-done', k < idx && idx !== -1);
        if (k >= vis.length) { d.style.display = 'none'; } else { d.style.display = ''; }
      });
    }

    function next() {
      var vis = visibleSteps();
      var idx = vis.indexOf(currentStep);
      if (idx < vis.length - 1) {
        currentStep = vis[idx + 1];
        showStep(currentStep);
      } else {
        showResult();
      }
    }

    function showResult() {
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      var reinigGoed = answers.reinig === 'goed';
      var spfGoed = answers.spf === 'ja';
      var title, text;
      if (!reinigGoed && !spfGoed) { title = data.r1; text = data.r1t; }
      else if (!reinigGoed && spfGoed) { title = data.r2; text = data.r2t; }
      else if (reinigGoed && !spfGoed) { title = data.r3; text = data.r3t; }
      else { title = data.r4; text = data.r4t; }

      root.querySelector('[data-result-title]').textContent = title;
      root.querySelector('[data-result-text]').textContent = text;

      var avondEl = root.querySelector('[data-result-avond]');
      if (answers.avond === 'nee' || answers.avond === 'soms') {
        avondEl.textContent = data.avond;
        avondEl.hidden = false;
      } else {
        avondEl.hidden = true;
      }

      result.classList.add('is-active');
      dots.forEach(function (d) { d.classList.remove('is-active'); d.classList.add('is-done'); });
    }

    root.querySelectorAll('.sc-chk__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.getAttribute('data-q');
        var val = btn.getAttribute('data-val');
        answers[q] = val;
        next();
      });
    });

    if (redo) redo.addEventListener('click', function () {
      answers = { reinig: null, creme: null, spf: null, avond: null };
      currentStep = 0;
      dots.forEach(function (d) { d.style.display = ''; });
      showStep(0);
    });

    showStep(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-door-de-jaren"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scyrs]').forEach(function (root) {
    var slides = root.querySelectorAll('.sc-yrs__slide');
    var num = root.querySelector('.sc-yrs__num');
    var range = root.querySelector('.sc-yrs__range');
    var fill = root.querySelector('.sc-yrs__fill');
    if (!slides.length) return;
    var interval = parseInt(root.dataset.interval, 10) || 3000;
    var current = 0, timer = null, paused = false, raf = null;

    function tweenYear(from, to, dur) {
      if (raf) cancelAnimationFrame(raf);
      var t0 = null;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        num.textContent = Math.round(from + (to - from) * p);
        if (p < 1) raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }

    function show(i, animateYear) {
      var prevYear = parseInt(slides[current].dataset.year, 10) || 0;
      current = (i + slides.length) % slides.length;
      var year = parseInt(slides[current].dataset.year, 10) || 0;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
      if (animateYear) { tweenYear(prevYear, year, 700); } else { num.textContent = year; }
      range.value = current;
      fill.style.width = ((current + 1) / slides.length * 100) + '%';
    }

    function start() { stop(); timer = setInterval(function () { if (!paused) show(current + 1, true); }, interval); }
    function stop() { if (timer) clearInterval(timer); }

    range.addEventListener('input', function () { show(parseInt(range.value, 10), true); start(); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });

    show(0, false);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-herbestel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scherbestel]').forEach(function (root) {
    var feedback = root.querySelector('[data-scherbestel-feedback]');
    root.querySelectorAll('[data-scherbestel-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        var original = btn.textContent;
        btn.textContent = 'Bezig...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Toegevoegd ✓';
          if (feedback) {
            feedback.hidden = false;
            feedback.textContent = 'Toegevoegd aan je mandje.';
          }
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
          if (feedback) { feedback.hidden = false; feedback.textContent = 'Er ging iets mis. Probeer opnieuw.'; }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-herbestelpagina"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-schb]').forEach(function (root) {
    var form = root.querySelector('[data-schb-form]');
    if (!form) return;
    var toggles = form.querySelectorAll('[data-schb-toggle]');
    var countEl = form.querySelector('[data-schb-count]');
    var submit = form.querySelector('[data-schb-submit]');
    var labelsEl = form.querySelector('[data-schb-labels]');
    var labels = { zero: 'Niets gekozen', one: '1 product gekozen', many: '{n} producten gekozen' };
    if (labelsEl) {
      try {
        var parsed = JSON.parse(labelsEl.textContent);
        if (parsed.zero) labels.zero = parsed.zero;
        if (parsed.one) labels.one = parsed.one;
        if (parsed.many) labels.many = parsed.many;
      } catch (e) {}
    }
    function sync() {
      var count = 0;
      toggles.forEach(function (t) {
        var index = t.getAttribute('data-index');
        var on = t.checked && !t.disabled;
        form.querySelectorAll('[data-schb-field][data-index="' + index + '"]').forEach(function (f) { f.disabled = !on; });
        if (on) count++;
      });
      if (countEl) {
        if (count === 0) countEl.textContent = labels.zero;
        else if (count === 1) countEl.textContent = labels.one;
        else countEl.textContent = labels.many.replace('{n}', count);
      }
      if (submit) submit.disabled = count === 0;
    }
    toggles.forEach(function (t) { t.addEventListener('change', sync); });
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function scStuck(el) {
      var pos = window.getComputedStyle(el).position;
      return pos === 'sticky' || pos === 'fixed';
    }

    function scSetAnchorOffset() {
      var total = 0;
      var group = document.querySelector('.shopify-section-group-header-group');

      if (group) {
        Array.prototype.forEach.call(group.children, function (el) {
          if (scStuck(el)) {
            total += el.offsetHeight;
          } else {
            var inner = el.querySelector('*');
            var found = Array.prototype.filter.call(el.querySelectorAll('*'), scStuck)[0];
            if (found) total += found.offsetHeight;
          }
        });
      }

      if (!total) {
        var hdr = document.querySelector('header');
        if (hdr && scStuck(hdr)) total = hdr.offsetHeight;
      }

      if (total > 0) {
        document.documentElement.style.setProperty('--sc-anchor-offset', total + 'px');
      }
    }

    scSetAnchorOffset();
    window.addEventListener('load', scSetAnchorOffset);
    window.addEventListener('resize', scSetAnchorOffset);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-herohome"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function scStuck(el) {
      var pos = window.getComputedStyle(el).position;
      return pos === 'sticky' || pos === 'fixed';
    }

    function scSetAnchorOffset() {
      var total = 0;
      var group = document.querySelector('.shopify-section-group-header-group');

      if (group) {
        Array.prototype.forEach.call(group.children, function (el) {
          if (scStuck(el)) {
            total += el.offsetHeight;
          } else {
            var found = Array.prototype.filter.call(el.querySelectorAll('*'), scStuck)[0];
            if (found) total += found.offsetHeight;
          }
        });
      }

      if (!total) {
        var hdr = document.querySelector('header');
        if (hdr && scStuck(hdr)) total = hdr.offsetHeight;
      }

      if (total > 0) {
        document.documentElement.style.setProperty('--sc-anchor-offset', total + 'px');
      }
    }

    scSetAnchorOffset();
    window.addEventListener('load', scSetAnchorOffset);
    window.addEventListener('resize', scSetAnchorOffset);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-hoe-het-werkt"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-schhw]').forEach(function (root) {
    var tabs = root.querySelectorAll('.sc-hhw__tab');
    var panels = root.querySelectorAll('.sc-hhw__panel');
    var media = root.querySelectorAll('.sc-hhw__mediaslide');
    if (!tabs.length) return;
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var current = 0;
    var timer = null;
    var paused = false;

    function show(i) {
      current = (i + tabs.length) % tabs.length;
      tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
      panels.forEach(function (p, k) { p.classList.toggle('is-active', k === current); });
      media.forEach(function (m, k) { m.classList.toggle('is-active', k === current); });
    }
    function start() {
      stop();
      timer = setInterval(function () { if (!paused) show(current + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); }

    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        show(k);
        start();
      });
    });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });

    show(0);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-mythbusting"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scmyth]').forEach(function (root) {
    root.querySelectorAll('.sc-myth__card').forEach(function (card) {
      card.addEventListener('click', function () {
        var flipped = card.classList.toggle('is-flipped');
        card.setAttribute('aria-pressed', flipped ? 'true' : 'false');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-productblok"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scbox]').forEach(function (root) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { root.classList.add('is-inview'); io.disconnect(); }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      root.classList.add('is-inview');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-productpagina"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scpp-media]').forEach(function (root) {
    var slides = root.querySelectorAll('.sc-pp__slide');
    var thumbs = root.querySelectorAll('.sc-pp__thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-go');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === idx); });
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });
  });

  document.querySelectorAll('[data-scpp-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.sc-pp__tab');
    var panels = root.querySelectorAll('.sc-pp__panel');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-tab');
        tabs.forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === idx); });
      });
    });
  });

  document.querySelectorAll('[data-scpp-counter]').forEach(function (el) {
    var from = parseInt(el.getAttribute('data-from'), 10);
    var to = parseInt(el.getAttribute('data-to'), 10);
    var finalText = el.getAttribute('data-final');
    if (isNaN(from) || isNaN(to) || to >= from) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) { el.textContent = finalText; return; }
    var fmt;
    try { fmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }); }
    catch (e) { el.textContent = finalText; return; }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || done) return;
        done = true; io.disconnect();
        var duration = 900, start = null;
        function frame(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var value = Math.round(from + (to - from) * eased);
          el.textContent = fmt.format(value / 100);
          if (p < 1) { requestAnimationFrame(frame); } else { el.textContent = finalText; }
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-spf-vergelijk"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sccmp]').forEach(function (root) {
    var stage = root.querySelector('.sc-cmp__stage');
    var range = root.querySelector('.sc-cmp__range');
    if (!stage || !range) return;

    function setPos(v) {
      v = Math.max(0, Math.min(100, v));
      stage.style.setProperty('--pos', v + '%');
      range.value = v;
    }
    range.addEventListener('input', function () { setPos(parseFloat(range.value)); });

    function fromEvent(e) {
      var rect = stage.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      setPos((x / rect.width) * 100);
    }
    var dragging = false;
    stage.addEventListener('pointerdown', function (e) { dragging = true; fromEvent(e); });
    window.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    window.addEventListener('pointerup', function () { dragging = false; });

    setPos(50);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-waarom-spf"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scspf]').forEach(function (root) {
    var counter = root.querySelector('.sc-spf__counter');
    var started = false;

    function runCounter() {
      if (!counter || started) return;
      started = true;
      var target = parseInt(counter.dataset.target, 10) || 80;
      var duration = 1200;
      var t0 = null;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / duration, 1);
        // ease-out
        var eased = 1 - Math.pow(1 - p, 3);
        counter.textContent = Math.round(eased * target);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            root.classList.add('is-inview');
            runCounter();
            io.disconnect();
          }
        });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      root.classList.add('is-inview');
      runCounter();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
